/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component} from '@angular/core';

import template from './welcome-political-page.component.html';
import {AppSharedModule} from '../common/app-shared.module';

@Component({
  standalone: true,
  imports: [AppSharedModule],
  selector: 'adn-welcome-political-page',
  template
})
export class WelcomePoliticalPageComponent {
}
